import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { ExternalLink } from '../../components/ExternalLink';
import { localDateTime } from '../../../util/intl.utils';
import { OrcidAuthorizeDTO } from '../../../api/admin';
import { OrcidRevokeRightsForm } from './OrcidRevokeRightsForm';
import { ConnectOrcidFormData } from './ConnectOrcidFormData';
import { OrcidGrandRightsForm } from './OrcidGrandRightsForm';
import { Mandant } from '../../../util/types';

interface Props {
  orcidAuthorize: OrcidAuthorizeDTO;
  revoke: () => void;
  submit: (data: ConnectOrcidFormData) => void;
  mandant: Mandant;
}

export const OrcidLinked = ({orcidAuthorize, revoke, submit, mandant}: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex flex-column gap-1'}>
      <ExternalLink
        href={`https://orcid.org/${orcidAuthorize.orcidID}`}
        externalIcon={true}
      >{`https://orcid.org/${orcidAuthorize.orcidID}`}</ExternalLink>
      {orcidAuthorize.tokenRevoked && <OrcidGrandRightsForm revoked={true} submit={submit} mandant={mandant} />}
      {!orcidAuthorize.tokenRevoked && <OrcidRevokeRightsForm orcidAuthorize={orcidAuthorize} revoke={revoke}  mandant={mandant}/>}
      <p>{`${intl.formatMessage({ id: `settings.orcid.lastUpdateFromOrcid` })}: ${localDateTime(orcidAuthorize.lastUpdateFromOrcid, intl.locale)}`}</p>
    </div>
  );
};
